import { NextPage } from 'next'

// Meta Tags
import MetaTags from '@/components/common/meta-tags'

// BreadCrumb
import BreadCrumb from '@/components/common/breadcrumb'

// Component
import ContactUsSection from '@/components/page-components/contact-page'

const ContactUsPage: NextPage = () => {
  return (
    <>
      <MetaTags title="Contact Us | Comfort - The Home Craft" />

      <BreadCrumb pageName="Contact" />

      <ContactUsSection />
    </>
  )
}

export default ContactUsPage
